import { render, staticRenderFns } from "./SelectCategoryRegister.vue?vue&type=template&id=3dc3331e&scoped=true&"
import script from "./SelectCategoryRegister.vue?vue&type=script&lang=js&"
export * from "./SelectCategoryRegister.vue?vue&type=script&lang=js&"
import style0 from "./SelectCategoryRegister.vue?vue&type=style&index=0&id=3dc3331e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc3331e",
  null
  
)

export default component.exports